import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "24",
  fill: "none",
  viewBox: "0 0 28 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.85 0h24.3c.358 0 .701.14.955.39.253.25.395.59.395.943v21.334c0 .353-.142.692-.395.942-.254.25-.597.391-.955.391H1.85c-.358 0-.701-.14-.955-.39a1.33 1.33 0 0 1-.395-.943V1.333C.5.98.642.641.895.391 1.15.14 1.492 0 1.85 0m18.176 16.715L24.8 12l-4.774-4.715-1.908 1.888L20.982 12l-2.864 2.828zM7.018 12l2.865-2.828-1.91-1.887L3.2 12l4.774 4.715 1.909-1.888zm5.961 6.667 4.914-13.334h-2.872l-4.914 13.334z"
    }, null, -1)
  ])))
}
export default { render: render }